// ABOUTME: Route guard component that blocks admin routes during impersonation
// ABOUTME: Displays error message when impersonating user tries to access admin pages

import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Alert, Typography } from '@mui/material';
import { useImpersonation } from '../hooks/useImpersonation';

interface ImpersonationGuardProps {
  children: React.ReactNode;
}

const ImpersonationGuard: React.FC<ImpersonationGuardProps> = ({ children }) => {
  const { isImpersonating } = useImpersonation();
  const location = useLocation();

  // Check if current route is an admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  // If impersonating and trying to access admin route, block it
  if (isImpersonating && isAdminRoute) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
          p: 3,
        }}
      >
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          <Typography variant="h6" gutterBottom>
            Admin Access Blocked During Impersonation
          </Typography>
          <Typography variant="body1">
            You cannot access admin routes while impersonating a user. Please exit impersonation first using the banner at the top of the page.
          </Typography>
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ImpersonationGuard;
